import {
    CalendarMonthOutlined,
    PersonOutlineOutlined,
} from "@mui/icons-material";
import { eventHandlerMessage } from "../functions/functions";
import { EventResponse } from "../types/types";
import NotificationCard from "./NotificationCard";

type TrackingEventAlertCardProps = {
    event: EventResponse;
};

const getEventPresentation = (eventName: string) => {
    switch (eventName) {
        case "sos":
            return { category: "EMERGÊNCIA", severity: "CRÍTICO", severityColor: "error" as const };
        case "powerCut":
        case "powerOff":
            return { category: "ENERGIA", severity: "CRÍTICO", severityColor: "error" as const };
        case "fuelLeak":
        case "deviceFuelDrop":
            return { category: "COMBUSTÍVEL", severity: "CRÍTICO", severityColor: "error" as const };
        case "geofenceEnter":
        case "geofenceExit":
            return { category: "CERCA", severity: "INFORMATIVO", severityColor: "info" as const };
        case "overSpeed":
        case "overspeed":
        case "deviceOverspeed":
            return { category: "VELOCIDADE", severity: "ATENÇÃO", severityColor: "warning" as const };
        case "hardAcceleration":
        case "hardBraking":
        case "hardCornering":
            return { category: "CONDUÇÃO", severity: "ATENÇÃO", severityColor: "warning" as const };
        case "lowBattery":
            return { category: "ENERGIA", severity: "ATENÇÃO", severityColor: "warning" as const };
        default:
            return { category: "EVENTO", severity: "INFORMATIVO", severityColor: "info" as const };
    }
};

const TrackingEventAlertCard = ({ event }: TrackingEventAlertCardProps) => {
    const presentation = getEventPresentation(event.name);
    const driverName = event.vehicle.driverName?.trim();
    const details = [
        {
            key: "event-date-time",
            icon: <CalendarMonthOutlined fontSize="small" color="action" />,
            text: `Ocorrido em: ${event.eventDateTime}`,
        },
        ...(driverName
            ? [{
                key: "driver",
                icon: <PersonOutlineOutlined fontSize="small" color="action" />,
                text: `Motorista: ${driverName}`,
            }]
            : []),
    ];

    return (
        <NotificationCard
            category={presentation.category}
            severity={presentation.severity}
            severityColor={presentation.severityColor}
            title={eventHandlerMessage(event.name)}
            subject={`${event.vehicle.name} - ${event.vehicle.vehiclePlate}`}
            details={details}
        />
    );
};

export default TrackingEventAlertCard;
